import { render, staticRenderFns } from "./PersonelForm.vue?vue&type=template&id=251d5bcb&scoped=true"
import script from "./PersonelForm.vue?vue&type=script&lang=ts"
export * from "./PersonelForm.vue?vue&type=script&lang=ts"
import style0 from "./PersonelForm.vue?vue&type=style&index=0&id=251d5bcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251d5bcb",
  null
  
)

export default component.exports